import { useEffect, useState } from 'react';
import { discountOffers, type DiscountOffers } from '../api/discountCode';

// Asks once what the store runs — codes to type, automatic discounts — for the cart and the order form alike; a
// failed answer offers neither rather than guessing.
export function useDiscountOffers(enabled: boolean): DiscountOffers {
  const [offers, setOffers] = useState<DiscountOffers>({ codes: false, automatic: false });
  useEffect(() => {
    if (!enabled) return;
    let live = true;
    discountOffers().then((next) => { if (live) setOffers(next); }).catch(() => undefined);
    return () => { live = false; };
  }, [enabled]);
  return offers;
}
